import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommonModuleRoutingModule} from './common-module-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ClientModule} from '../client/client.module';
import {BaseModule} from '../base/base.module';
import {AboutUsComponent} from './about-us/about-us.component';
import {SignInComponent} from './sign-in/sign-in.component';

@NgModule({
  declarations: [
    AboutUsComponent,
    SignInComponent
  ],
  imports: [
    CommonModule,
    CommonModuleRoutingModule,
    FormsModule,
    ClientModule,
    BaseModule,
    ReactiveFormsModule
  ],
  exports: [
    AboutUsComponent
  ]
})
export class CommonModuleModule {
}
